import React, { useEffect, useState } from "react";
import {
  Col,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import { Link, useParams, useHistory } from "react-router-dom";
import classnames from "classnames";

//import images
import avatar2 from "../../assets/images/users/avatar-2.jpg";
import avatar8 from "../../assets/images/users/avatar-8.jpg";
import avatar3 from "../../assets/images/users/avatar-3.jpg";
import avatar6 from "../../assets/images/users/avatar-6.jpg";
import bell from "../../assets/images/svg/bell.svg";

//SimpleBar
import SimpleBar from "simplebar-react";
import axiosInstance from "../../axiosConfig";

const MyCartDropdown = () => {
  const history = useHistory();

  //Début code pour get le client sélectionné
  const clientId = useParams("id");
  //Dropdown Toggle
  const [isNotificationDropdown, setIsNotificationDropdown] = useState(false);
  const toggleNotificationDropdown = () => {
    setIsNotificationDropdown(!isNotificationDropdown);
  };

  //Tab
  const [activeTab, setActiveTab] = useState("1");
  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  function formatDate(date) {
    const dateObject = new Date(date);
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "short",
    };
    return dateObject.toLocaleDateString(undefined, options);
  }

  function getElapsedTime(startDate) {
    const start = new Date(startDate);
    const end = new Date(); // Date actuelle
    let temps;

    const diffMilliseconds = end - start;

    const diffSeconds = Math.floor(diffMilliseconds / 1000);
    const diffMinutes = Math.floor(diffSeconds / 60);
    const diffHours = Math.floor(diffMinutes / 60);
    const diffDays = Math.floor(diffHours / 24);
    const diffMonths = Math.floor(diffDays / 30); // Approximation
    const diffYears = Math.floor(diffMonths / 12);
    const diffCenturies = Math.floor(diffYears / 100);

    if (diffCenturies > 0) {
      temps = `${diffCenturies} siecle(s)`;
    } else if (diffYears > 0) {
      temps = `${diffYears} an(s)`;
    } else if (diffMonths > 0) {
      temps = `${diffMonths} mois`;
    } else if (diffDays > 0) {
      temps = `${diffDays} jour(s)`;
    } else if (diffHours > 0) {
      temps = `${diffHours} heure(s)`;
    } else if (diffMinutes > 0) {
      temps = `${diffMinutes} min(s)`;
    } else if (diffSeconds > 0) {
      temps = `${diffSeconds} sec(s)`;
    } else {
      temps = `à l'instant`;
    }

    return temps;
  }

  const [coursesAttenteList, setCoursesAttenteList] = useState([]);
  const [coursesAttenteListShow, setCoursesAttenteListShow] = useState([]);
  const fetchCourseList = async () => {
    try {
      const course_attente_list = await axiosInstance.get(`/coursedetail`);

      const getCourses = course_attente_list.data.data
        .filter((course) => course.course_status === "En attente")
        .sort((a, b) => new Date(a.date_course) - new Date(b.date_course));

      setCoursesAttenteList(getCourses);
      setCoursesAttenteListShow(getCourses.slice(0, 5));

      // console.log(course_attente_list);
      // console.log("Course List En attente: ", getCourses);
    } catch (err) {
      console.log(err);
    }
  };

  const [livraisonsAttenteList, setLivraisonsAttenteList] = useState([]);
  const [livraisonsAttenteListShow, setLivraisonsAttenteListShow] = useState(
    []
  );
  const fetchLivraisonList = async () => {
    try {
      const livraison_attente_list = await axiosInstance.get(
        `/livraisondetail`
      );

      const getLivraison = livraison_attente_list.data.data
        .filter(
          (livraison) =>
            livraison.statut === "En attente" &&
            livraison.conducteur_id === null
        )
        .sort((a, b) => new Date(a.created_at) - new Date(b.created_at));

      setLivraisonsAttenteList(getLivraison);
      setLivraisonsAttenteListShow(getLivraison.slice(0, 5));

      // console.log(livraison_attente_list);
      // console.log("Livraison List: ", livraison_attente_list.data.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchCourseList();
    fetchLivraisonList();
  }, []);

  return (
    <React.Fragment>
      <Dropdown
        isOpen={isNotificationDropdown}
        toggle={toggleNotificationDropdown}
        className="topbar-head-dropdown ms-1 header-item"
      >
        <DropdownToggle
          type="button"
          tag="button"
          className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
        >
          <i className="bx bx-car fs-22"></i>
          <span
            className="position-absolute topbar-badge translate-middle fs-10 badge rounded-pill bg-danger"
            style={{
              fontSize: "1rem",
            }}
          >
            {coursesAttenteList.length + livraisonsAttenteList.length > 10
              ? "+9"
              : coursesAttenteList.length + livraisonsAttenteList.length}
            <span className="visually-hidden">unassign courses</span>
          </span>
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
          <div className="dropdown-head bg-primary bg-pattern rounded-top">
            <div className="p-3">
              <Row className="align-items-center">
                <Col>
                  <h6 className="m-0 fs-16 fw-semibold text-white">
                    {" "}
                    Commandes{" "}
                  </h6>
                </Col>
                <div className="col-auto dropdown-tabs">
                  <span className="badge badge-soft-light fs-13">
                    {" "}
                    {coursesAttenteList.length +
                      livraisonsAttenteList.length}{" "}
                    Commande(s)
                  </span>
                </div>
              </Row>
            </div>

            <div className="px-2 pt-2">
              <Nav className="nav-tabs dropdown-tabs nav-tabs-custom">
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === "1" })}
                    onClick={() => {
                      toggleTab("1");
                    }}
                  >
                    Courses
                    <sup>
                      {coursesAttenteList && coursesAttenteList.length > 100
                        ? "+99"
                        : coursesAttenteList.length}
                    </sup>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === "2" })}
                    onClick={() => {
                      toggleTab("2");
                    }}
                  >
                    Livraisons
                    <sup>
                      {livraisonsAttenteList &&
                      livraisonsAttenteList.length > 100
                        ? "+99"
                        : livraisonsAttenteList.length}
                    </sup>
                  </NavLink>
                </NavItem>
              </Nav>
            </div>
          </div>

          <TabContent activeTab={activeTab}>
            <TabPane tabId="1" className="py-2 ps-2">
              <SimpleBar style={{ maxHeight: "300px" }} className="pe-2">
                {coursesAttenteList && coursesAttenteList.length > 0 ? (
                  <>
                    {coursesAttenteListShow.map((course, key) => {
                      return (
                        <div
                          key={key}
                          className="text-reset notification-item d-block dropdown-item position-relative"
                        >
                          <div className="d-flex">
                            <div className="avatar-xs me-3">
                              <span className="avatar-title bg-soft-warning text-warning rounded-circle fs-16">
                                <i className="bx bx-message-alt-error"></i>
                              </span>
                            </div>
                            <div className="flex-1">
                              <Link
                                type="button"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setIsNotificationDropdown(false);
                                  history.push("/courses-attente");
                                }}
                                className="stretched-link"
                              >
                                <h6 className="mt-0 mb-2 lh-base">
                                  <Link
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setIsNotificationDropdown(false);
                                      history.push(
                                        `client/${course.client_id}`
                                      );
                                    }}
                                  >
                                    {course.first_name_client}{" "}
                                    {course.last_name_client}
                                  </Link>{" "}
                                  a commandé une{" "}
                                  <b>{course.designation_type_engin}</b> pour
                                  une course de{" "}
                                  <span className="text-secondary">
                                    {course.adresse_depart}
                                  </span>{" "}
                                  pour{" "}
                                  <span className="text-secondary">
                                    {course.adresse_destination}
                                  </span>
                                  !
                                </h6>
                              </Link>
                              <p className="mb-0 fs-11 fw-medium text-uppercase text-muted">
                                <span>
                                  <i className="mdi mdi-clock-outline"></i>
                                  Il y a {getElapsedTime(course.date_course)}
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                      );
                    })}

                    <div className="my-3 text-center">
                      <button
                        type="button"
                        className="btn btn-soft-success waves-effect waves-light"
                        onClick={(e) => {
                          e.preventDefault();
                          setIsNotificationDropdown(false);
                          history.push("/courses-attente");
                        }}
                      >
                        Voir tous{" "}
                        <i className="ri-arrow-right-line align-middle"></i>
                      </button>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="w-25 w-sm-50 pt-3 mx-auto">
                      <i className="bx bx-car fs-3"></i>
                    </div>
                    <div className="text-center pb-5 mt-2">
                      <h6 className="fs-18 fw-semibold lh-base">
                        Hey! Aucune Course{" "}
                      </h6>
                    </div>
                  </>
                )}
              </SimpleBar>
            </TabPane>

            <TabPane tabId="2" className="py-2 ps-2">
              <SimpleBar style={{ maxHeight: "300px" }} className="pe-2">
                {livraisonsAttenteList && livraisonsAttenteList.length > 0 ? (
                  <>
                    {livraisonsAttenteListShow.map((livraison, key) => {
                      return (
                        <div
                          key={key}
                          className="text-reset notification-item d-block dropdown-item position-relative"
                        >
                          <div className="d-flex">
                            <div className="avatar-xs me-3">
                              <span className="avatar-title bg-soft-warning text-warning rounded-circle fs-16">
                                <i className="bx bx-message-alt-error"></i>
                              </span>
                            </div>
                            <div className="flex-1">
                              <Link
                                className="stretched-link"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setIsNotificationDropdown(false);
                                  history.push(
                                    `/livraisons-attente/${livraison.id}`
                                  );
                                }}
                              >
                                <h6 className="mt-0 mb-2 lh-base">
                                  <Link
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setIsNotificationDropdown(false);
                                      history.push(
                                        `client/${livraison.client_id}`
                                      );
                                    }}
                                  >
                                    {livraison.first_name_client}{" "}
                                    {livraison.last_name_client}
                                  </Link>{" "}
                                  a commandé une{" "}
                                  <b>{livraison.designation_type_engin}</b> pour
                                  une livraison de{" "}
                                  <span className="text-secondary">
                                    {livraison.adresse_enlevement}
                                  </span>{" "}
                                  pour{" "}
                                  <span className="text-secondary">
                                    {livraison.adresse_livraison}
                                  </span>
                                  !
                                </h6>
                              </Link>
                              <p className="mb-0 fs-11 fw-medium text-uppercase text-muted">
                                <span>
                                  <i className="mdi mdi-clock-outline"></i>
                                  Il y a {getElapsedTime(livraison.date_course)}
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                      );
                    })}

                    <div className="my-3 text-center">
                      <button
                        type="button"
                        className="btn btn-soft-success waves-effect waves-light"
                        onClick={(e) => {
                          e.preventDefault();
                          setIsNotificationDropdown(false);
                          history.push("/livraisons-attente");
                        }}
                      >
                        Voir tous{" "}
                        <i className="ri-arrow-right-line align-middle"></i>
                      </button>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="w-25 w-sm-50 pt-3 mx-auto">
                      <i className="bx bx-car fs-3"></i>
                    </div>
                    <div className="text-center pb-5 mt-2">
                      <h6 className="fs-18 fw-semibold lh-base">
                        Hey! Aucune Livraison{" "}
                      </h6>
                    </div>
                  </>
                )}
              </SimpleBar>
            </TabPane>
          </TabContent>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default MyCartDropdown;
